export const postingSuppressionsMock = {
  "list": [],
  "total": 0,
  "startNum": 0,
  "endNum": 0,
  "numRequested": 2000,
  "self": "/posting-suppressions",
  "elapsed": 27
}